// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji-module--emoji--3fH8J"};